import React from "react";
import "./modal.css";
import closeBtn from "../img/close.png";
import Minter from "./minter.js";

function Modal({ closeModal }) {
    return (
      <div className="modalBackground">
        <div className="modalContainer">
          <div className="titleCloseBtn">
            <button
              onClick={() => {
                closeModal(false);}}>
                    <img className="closeBtn" src={closeBtn}  alt="closeBtn"/>
            </button>
          </div>
          <div className="title">
            <h3>CONNECT WALLET</h3>
          </div>
          <div className="body">
            <p>By connecting your wallet, you agree to our <a href="#">Terms of Service</a> and our <a href="#">Privacy Policy</a>.</p>
          </div>
          <div className="footer">
            <Minter/>
            <p><a href="#">Learn more about wallets</a></p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Modal;